export default {
    // 消息中间件信息查询接口
    listUserInfos(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getAllUsers', params, response);
    },
    // 消息中间件删除接口
    deleteUserInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/deleteUserInfo', params, response);
    },
    // 消息添加接口
    insertUserInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/insertUserInfo', params, response);
    },
    // 消息更新接口
    updateUserInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/updateUserInfo', params, response);
    },
    // 消息中间件信息查询接口
    getRoleInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getRoleInfo', params, response);
    },
    getUserRole(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getUserRole', params, response);
    },
    getUserRoleInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getUserRoleInfo', params, response);
    },
    // 消息中间件信息查询接口
    getUserExtends(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getUserExtends', params, response);
    },
    // 消息中间件信息查询接口
    getUserIpList(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getUserIpList', params, response);
    },
    // 消息中间件信息查询接口
    getUserMacList(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getUserMacList', params, response);
    },
    getUserTimeList(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getUserTimeIntervalList', params, response);
    },

    getUserExtendsValues(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getUserExtendsValues', params, response);
    },
    getUserInfoByName(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getUserInfoByName', params, response);
    },
    // 消息中间件信息查询接口
    checkUserInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/authCtrl/login', params, response);
    },
    // 消息更新接口
    getSysList(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/sys/getSysList', params, response);
    },
    // 获取菜单信息
    getOrgList(url, hostName, params, response) {
        window.vue.$apiAxios.postRequestBody(url, params, response, hostName);
    },
    // 获取菜单信息
    exportExcel(params, requestType, response) {
        window.vue.$apiAxios.download('/auth/user/exportExcel', params, requestType, response);
    },
    // 重置密码
    resetPassword(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/resetPassword', params, response);
    },
    // 获取权限
    getUserAuthInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getUserAuthInfo', params, response);
    },
    // 校验用户Ip是否重复
    getUserIpInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getUserIpInfo', params, response);
    },
    // 校验用户Mac是否重复
    getUserMacInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getUserMacInfo', params, response);
    },
    // 获取所有角色
    getAllRoleByType(response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getAllRoleByType', null, response);
    },
    // 获取自定义角色
    getCheckedRole(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getCheckedRole', params, response);
    },
    getUserAccessResInfoList(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/getUserAccessResInfoList', params, response);
    },
    validateResConflict(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/validateResConflict', params, response);
    },
    getAllStaffInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/pangu/staffManager/getAllStaffInfo', params, response);
    },
    batchAddUserRoles(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/batchAddUserRoles', params, response);
    },
    batchDeleteUserRoles(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/batchDeleteUserRoles', params, response);
    },
    //查询token列表
    queryTokenList(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/token/queryTokenList', params, response);
    },
    //创建token
    creatThirdPartyToken(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/token/creatThirdPartyToken', params, response);
    },
    // 根据组标识获取值列表信息
    getDictValuesByTag(params, response) {
        window.vue.$apiAxios.get('/setting/dictController/getDictValuesByTag', params, response);
    },
    //查询有权限的资源
    queryFinetuneInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/user/queryFinetuneInfoByUserId', params, response);
    },
    orgFind(params, response) {
        window.vue.$apiAxios.postRequestBody('/pangu/OrgManagerController/find', params, response);
    },
    orgStructureFind(params, response) {
        window.vue.$apiAxios.postRequestBody('/pangu/OrgStructureController/findOrgStructure', params, response);
    }
};
